export default function FoodSecurityGap() {
  return (
    <section
      id="gap"
      data-testid="food-security-gap-section"
      className="relative bg-sand py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] text-rust mb-6">
              The National Picture
            </div>
            <h2
              data-testid="gap-heading"
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-charcoal"
            >
              Australia's
              <span className="block italic text-rust">food security gap.</span>
            </h2>

            <div className="mt-12 hidden md:block relative">
              <img
                src="https://images.unsplash.com/photo-1611564393101-b834b74a9b48"
                alt="Remote outback road representing fragile supply chains"
                className="w-full aspect-[4/5] object-cover"
              />
              <div className="absolute -bottom-6 -right-6 bg-charcoal text-sand p-6 max-w-xs">
                <div className="text-xs uppercase tracking-[0.25em] text-ochre/80">
                  Fragile by design
                </div>
                <div className="mt-2 font-serif text-xl leading-snug">
                  Optimised for efficiency, not resilience.
                </div>
              </div>
            </div>
          </div>

          <div className="md:col-span-6 md:col-start-7 space-y-7 text-base md:text-lg leading-relaxed text-ink">
            <p>
              Australia is one of the world's largest food-producing nations,
              yet many remote Aboriginal and Torres Strait Islander communities
              remain highly vulnerable to food insecurity.
            </p>
            <p>
              Across remote Australia, communities sit at the most exposed end
              of the national food system — where rising freight costs, fragile
              supply chains, climate disruption and food price volatility are
              felt first and hardest.
            </p>
            <p className="font-serif text-2xl md:text-3xl text-charcoal italic leading-snug border-l-2 border-rust pl-6 my-10">
              Australia's food system has been optimised for efficiency,
              not&nbsp;resilience.
            </p>
            <p>
              Growing Country has been developed in response to this growing
              national challenge — strengthening local food production,
              community capability and regional resilience through practical
              Indigenous-led food systems.
            </p>

            <div className="pt-6 border-t border-stone-line/70 grid grid-cols-2 gap-x-8 gap-y-6 mt-10">
              {[
                { label: "Scale", value: "National" },
                { label: "Lens", value: "Resilience Infrastructure" },
                { label: "Model", value: "Indigenous-Led" },
                { label: "Horizon", value: "Long-Term Systems" },
              ].map((m) => (
                <div key={m.label}>
                  <div className="text-[11px] uppercase tracking-[0.25em] text-ink/60 mb-1">
                    {m.label}
                  </div>
                  <div className="font-serif text-xl text-charcoal">
                    {m.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
